import React, {Fragment} from 'react'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { Form, Formik, ErrorMessage } from 'formik';
import { FormattedMessage } from 'react-intl';
import {onEnter, onExit} from "../../../../config/customModalFunctions";
import {SendEmailClientForm} from "../forms/SendEmailClientForm";
import {
    SendEmailClientSchema,
} from "../../../../helpers/schemas";
import {Messages} from "../../../layout/Messages/Messages";
import {
    NOTIFICATION_SEND_EMAIL_USER,
} from "../../../../config/notifications";
import { sendEmailUser as sendEmailUserApi } from "../../../../api/clients/emails";
import { uuid } from '../../../../helpers/uuid';
import { CUSTOM_EMAIL_TEMPLATES } from '../../../../config/constants';
import { NOTIFICATION_ERROR } from '../../../../store/actions/types';

const SendEmailClientModal = (props) => {
  const { closeModal, user, actionCallback } = props;

  function sendEmailUser(values) {
    let payload = {
      template: values.template,
      test: values.test === "true",
      userId: values.userId,
      firstName: values.firstName,
      email: values.email,
      notificationId: NOTIFICATION_SEND_EMAIL_USER,
    };

    sendEmailUserApi( payload ).then( (data) => {
      if (data && data.status === 204) {
        actionCallback();
      }
      
      closeModal();
    } );
  }

  return (
    <Modal
      isOpen={props.showModal}
      toggle={closeModal}
      onEnter={onEnter}
      onExit={onExit}
      centered
      size="lg"
      returnFocusAfterClose={false}
    >
      <ModalHeader toggle={closeModal}>
        <FormattedMessage id="components.pages.clients.modals.send_email_user.modal_title"/>
      </ModalHeader>
      <ModalBody>
        <Formik
          initialValues={{
            template: CUSTOM_EMAIL_TEMPLATES.CONTACT_AFTER_REGISTER.value,
            test: "false",
            userId: uuid(user.id),
            firstName: user.first_name,
            email: user.email,
          }}
          validationSchema={SendEmailClientSchema}
          onSubmit={(values) => {
            sendEmailUser(values);
          }}
        >
          {formikProps => (
            <Fragment>
              <Messages
                color="danger"
                notificationId="formValidation"
                type={NOTIFICATION_ERROR}
                formikProps={formikProps}
              >
                <ErrorMessage
                  name="template"
                  component="div"
                  data-testid="errors-template"
                  className="field-error"
                />
                <ErrorMessage
                  name="test"
                  component="div"
                  data-testid="errors-test"
                  className="field-error"
                />
                <ErrorMessage
                  name="userId"
                  component="div"
                  data-testid="errors-userId"
                  className="field-error"
                />
                <ErrorMessage
                  name="firstName"
                  component="div"
                  data-testid="errors-firstName"
                  className="field-error"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  data-testid="errors-email"
                  className="field-error"
                />
              </Messages>
              <Form>
                <SendEmailClientForm
                  formikProps={formikProps}
                />
                <div className="text-center text-sm-right py-3 mt-4">
                  <Button
                    className="mt-2 mt-sm-0"
                    name="add"
                    type="submit"
                    color="primary"
                  >
                    <FormattedMessage id="button.send"/>
                  </Button>
                  <Button className="mt-2 mt-sm-0" name="cancel" color="primary"
                          onClick={closeModal}>
                    <FormattedMessage id="button.cancel"/>
                  </Button>
                </div>
              </Form>
            </Fragment>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  )
}

export { SendEmailClientModal }
